import { useAuthState } from '../../utilities/contexts/auth-state-context';
import UserUtil from '../../utilities/user-util';
import { SwitchOrganizationHierarchyModal } from '../switch-organization-hierarchy-modal/switch-organization-hierarchy-modal';
import { SwitchOrganizationModal } from '../switch-organization-modal/switch-organization-modal';

type OrganizationSwitcherModalProps = {
    open: boolean,
    setOpen: (value: boolean | ((prevVar: boolean) => boolean)) => void,
    setIsSwitching: (value: boolean | ((prevVar: boolean) => boolean)) => void
}

export const OrganizationSwitcherModal = (props: OrganizationSwitcherModalProps) => {
    const { state } = useAuthState();

    if (UserUtil.isSuperAdmin(state.claims)) {
        return <SwitchOrganizationModal {...props} />;
    }

    return <SwitchOrganizationHierarchyModal {...props} />;
}
